import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type Props = {
  pageNum: 1 | 2 | 3;
  pagesCount: number;
};

const Headline = ({ pageNum, pagesCount }: Props) => {
  const { t } = useTranslation();
  let title = null;

  switch (pageNum) {
    case 1:
      title = t("chooseGrassSize");
      break;
    case 2:
      title = t("selectFrequency");
      break;
    case 3:
      title = t("addAnAccessory");
      break;

    default:
      break;
  }
  return (
    <div className={styles.headline}>
      <h1>{title}</h1>
      <div className={styles.pageCounter}>
        <div className={styles.progressBar}>
          <div
            className={styles.progress}
            style={{
              width: `${(100 / pagesCount) * pageNum}%`,
            }}
          ></div>
        </div>
        <div className={styles.pageInfo}>
          <p>
            <span>{pageNum}</span>
            <span>{t("of")}</span>
            <span>{pagesCount}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Headline;
